import React from 'react';
import { ReducerKeys } from 'redux/config';
import withReducer from 'redux/withReducer';
import RegisterForm from './components/Form';
import Title from 'components/atoms/Title';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { TranlsationKey } from './configuration';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const RegistrationForm = () => {
  return (
    <div>
      <Title
        style={{ textAlign: 'center' }}
        subTitle={
          <TranslatedTextV2
            defaultText="Please fill in the details below"
            translationKey={`${TranlsationKey}.signupSubtitle`}
          />
        }
      >
        <TranslatedTextV2
          defaultText="Signup with your email"
          translationKey={`${TranlsationKey}.signupTitle`}
        />
      </Title>
      <RegisterForm />
      {/* <Typography
        variant="h6"
        style={{ fontSize: 12, textAlign: 'center', fontWeight: 400 }}
      >
        <TranslatedTextV2
          defaultText="By pressing Send request, you agree that we may contact you via phone/text and/or email about your inquiry, which may involve the use of automated means. You also agree to our"
          translationKey={`${TranlsationKey}.termsConditions`}
        />
        <Link style={{ marginLeft: 5 }} to="">
          <TranslatedTextV2
            defaultText="Terms of Use"
            translationKey={`${TranlsationKey}.termsConditionsClick`}
          />
        </Link>
      </Typography> */}
    </div>
  );
};

export default withReducer(ReducerKeys.REGISTER_REDUCER)(RegistrationForm);
